import { useState } from "react";
import { Link } from "react-router-dom";
import useTriggeredAPICall from "../../../hooks/fetch-hooks/useTriggeredAPICall";
import { useAuthInfo } from "../../../context/AuthContext";
import { successfulToast } from "../../../util/toastNotifications";
import { errorToast } from "../../../util/toastNotifications";
import { isValidEmail } from "../../../util/stringUtils";

import Logo from "../../../assets/images/logo.svg";
import FormFieldText from "../../input/FormFieldText";

const VerifyAccount = (props) => {
  const [email, setEmail] = useState("");
  const { fetchData } = useTriggeredAPICall();
  const { logout } = useAuthInfo();

  const handleFieldUpdate = (e) => {
    setEmail(e.target.value);
  };
  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = {
      email: email,
    };

    fetchData("/auth/send-verify-email", "POST", payload, null)
      .then(async () => {
        successfulToast("Verification link sent!");
        await logout();
      })
      .catch((err) => {
        console.error("Send verify email: ", err);
        errorToast("Error sending email");
      })
      .finally(() => setEmail(""));
  };

  return (
    <div className="mt-32 center">
      <Link to="/login">
        <img className="mb-16 height-10" src={Logo} alt="Logo" />
      </Link>
      <div className="width-500px height-600px py-8 px-16 card center">
        <h2>Verify Account</h2>
        <p>
          Please enter your email address to get an account verification link.
        </p>
        <form onSubmit={handleSubmit}>
          <FormFieldText
            name="email"
            label="Email"
            placeholder="Enter your email..."
            type="email"
            value={email}
            onChange={handleFieldUpdate}
          ></FormFieldText>

          <button type="submit" disabled={!email && !isValidEmail(email)}>
            Send Email
          </button>
        </form>
      </div>
    </div>
  );
};
export default VerifyAccount;
